import {NgModule} from '@angular/core';
import {KCoreModule} from '@ngx-k/core';


@NgModule({
	declarations: [],
	exports: [],
	imports: [
		KCoreModule
	]
})
export class KComponentsModule {
}
